// extracted by mini-css-extract-plugin
module.exports = {"errorImage":"ErrorPage_errorImage__3elgL","fade":"ErrorPage_fade__2npiL","top":"ErrorPage_top__3rMmi"};